import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { ShareUpdateEmailComponent } from '../share-update-email/share-update-email.component';
import { AccountService } from 'src/app/pages/account/services/account.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ShareModule } from 'ngx-sharebuttons';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgClass, NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';

@Component({
    selector: 'app-share-update',
    templateUrl: './share-update.component.html',
    styleUrls: ['./share-update.component.scss'],
    standalone: true,
    imports: [FlexModule, MatButtonModule, NgClass, ExtendedModule, MatDialogModule, NgIf, ShareModule]
})
export class ShareUpdateComponent {
	shareLink: string = '';
	content: string = '';
	messageContent: string = '';
	date: string = '';
	isLoggedIn: boolean = false;
	disableSendEmail: boolean = false;
	@Input() disableSocialShare: boolean = false;
	@Input() currentFundraiser: any;
	noDonationNote: boolean = true;

	constructor(
		public router: Router,
		public _accountService: AccountService,
		public dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA)
		public data: {
			update: any;
			slug: string;
			currentFundraiser: any;
			shared: number;
		},
		public dialogRef: MatDialogRef<ShareUpdateComponent>
	) {}

	ngOnInit(): void {
		this.getLoggedInInfo();
		const parser = new DOMParser();
		const htmlString = this.data?.update?.content;
		const doc = parser.parseFromString(htmlString, 'text/html');
		this.content = doc.body?.textContent || '';

		let splitted = this.router.url.split('/');
		this.shareLink =
			environment.homeUrl +
			'/' +
			this._accountService.getLocaleId() +
			'/' +
			splitted[1] +
			'/' +
			splitted[2];
		this.router.url;

		const maxCharacters = 500;
		const title = this.data.currentFundraiser.title;
		this.messageContent = this.generateMessage(maxCharacters, this.content);

		this.disableSendEmail =
			this.data.shared === undefined ||
			this.data.shared === null ||
			this.data.shared == 1 ||
			this.data?.currentFundraiser?.donation?.count == 0;

		this.noDonationNote = this.data?.currentFundraiser?.donation?.count == 0;

		this.date = this.data?.update?.date;

		const ellipsis = '...';
		if (this.content.length > 160) {
			this.content =
				this.content.substring(0, maxCharacters - ellipsis.length) + ellipsis;
		}
	}

	getLoggedInInfo() {
		this._accountService.getLoginInformation().subscribe((data: Boolean) => {
			if (data == true) {
				this.isLoggedIn = true;
			} else {
				this.isLoggedIn = false;
			}
		});
	}

	generateMessage(maxCharacters: number, content: string): string {
		const ellipsis = '...';
		if (content.length > maxCharacters) {
			content =
				content.substring(0, maxCharacters - ellipsis.length) + ellipsis;
		}
		return content;
	}

	onSendEmailClick() {
		const dialogRef = this.dialog.open(ShareUpdateEmailComponent, {
			maxHeight: '70vh',
			maxWidth: '85vh',
			minWidth: '7vh',
			data: {
				fundraiserId: this.data?.currentFundraiser?.id,
				slug: this.data?.currentFundraiser?.slug,
				updateId: this.data?.update?.id,
				locale: this._accountService.getLocaleId(),
			},
		});
		this.dialogRef.close();
	}

	onCloseClick() {
		this.dialogRef.close();
	}
}
